// extracted by mini-css-extract-plugin
module.exports = {"how_works":"HowWorks_how_works__0L5FC"};